import styled from 'styled-components'
import { getFontStyle } from '@diversioteam/diversio-ds'

export const RatingListWrapper = styled.ul`
    padding: 0;
    list-style-type: none;
    display: flex;
    justify-content: space-around;
`

export const RatingListItem = styled.li`
    display: flex;
    flex-direction: column;
    gap: 10px;
    align-items: center;
`

export const RatingListItemIndex = styled.span`
    color: ${({ theme }) => theme.colors.secondary400};

    ${getFontStyle('p01Regular')}
`
